import React from 'react';
import { useTranslation } from 'react-i18next';

export const LabelAndURL: React.FunctionComponent<{
  label: string;
  href: string;
  website: string;
}> = ({ label, href, website }) => {
  const { t } = useTranslation();
  return (
    <>
      {t(label)}{' '}
      <a href={href} target="_blank" rel="noopener">
        {website}
      </a>
    </>
  );
};
